import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdAccountsId } from '@treadinc/horizon-api-spec';

import { Account } from '~hooks/useAccount/models';
import { useStores } from '~store';
import { Nullable } from '~types/Nullable';
import { getEffectiveUserCompanyId } from '~utils/user/user-utils';

export const accountQueryOptions = (companyId: string, accountId?: Nullable<string>) =>
  queryOptions({
    queryKey: ['account', companyId, accountId],
    queryFn: accountId
      ? async ({ signal }) => {
          const response = await getV1CompaniesCompanyIdAccountsId({
            path: { 'company-id': companyId, id: accountId },
            signal,
          });

          return Account.parse(response.data.data);
        }
      : skipToken,
    retry: false,
  });

// Failures are deliberately silent: callers render supplementary account details only.
export default function useAccountQuery(
  accountId?: Nullable<string>,
  companyId?: Nullable<string>,
) {
  const { userStore } = useStores();
  const effectiveCompanyId = getEffectiveUserCompanyId(userStore);
  const { data, isLoading } = useQuery(
    accountQueryOptions(companyId || effectiveCompanyId, accountId),
  );

  return { account: data ?? null, isLoading };
}
